import 'whatwg-fetch';

import enableTabbing from './modules/EnableTabbing';
import lazyLoad from './modules/LazyLoad';
import copyToClipboard from './modules/CopyToClipboard';
import scrollToX from './modules/ScrollToX';
import familyConnectionsSlider from './modules/FamilyConnectionsSlider';
import surprisingSlider from './modules/SurprisingSlider';
import godparentsSlider from './modules/GodparentsSlider';
import inLawsSlider from './modules/InLawsSlider';

enableTabbing();
lazyLoad();
copyToClipboard();
scrollToX();
familyConnectionsSlider();
surprisingSlider();
godparentsSlider();
inLawsSlider();
